import React from 'react'

const BookingsDash = () => {
  return (
    <div>bookingsDash</div>
  )
}

export default BookingsDash